import SmartProductCard from "./SmartProductCard";

export default function DiscoveryRails({ topSearched, topPurchased, trendingCats,
                                          onPickQuery, onPickCategory,
                                          onOpen, onAdd, inWishlist,
                                          onToggleWishlist }) {
  const anything = (topSearched?.length || 0) +
                   (topPurchased?.length || 0) +
                   (trendingCats?.length || 0);
  if (!anything) return null;
  return (
    <div className="hpz-discover" data-testid="plaza-discovery">
      {topSearched?.length > 0 && (
        <section className="hpz-discover__chips"
                  data-testid="plaza-top-searched">
          <header><h3>Most searched this week</h3></header>
          <div className="hpz-discover__chip-row">
            {topSearched.slice(0, 10).map((t, i) => (
              <button key={i}
                       className="hpz-discover__chip"
                       onClick={() => onPickQuery(t.query)}
                       data-testid={`plaza-trending-q-${i}`}>
                {t.query}
                <span className="hpz-discover__chip-count">{t.count}</span>
              </button>
            ))}
          </div>
        </section>
      )}

      {trendingCats?.length > 0 && (
        <section className="hpz-discover__chips"
                  data-testid="plaza-trending-cats">
          <header><h3>Trending categories</h3></header>
          <div className="hpz-discover__chip-row">
            {trendingCats.slice(0, 8).map((c, i) => (
              <button key={c.category_id || i}
                       className="hpz-discover__chip hpz-discover__chip--cat"
                       onClick={() => onPickCategory(c.category_id)}
                       data-testid={`plaza-trending-cat-${i}`}>
                {(c.category_path || "").split(">").pop().trim() || "Category"}
                {c.views_7d > 0 && (
                  <span className="hpz-discover__chip-count">
                    {c.views_7d} views
                  </span>
                )}
              </button>
            ))}
          </div>
        </section>
      )}

      {topPurchased?.length > 0 && (
        <section className="hpz-shop__reco"
                  data-testid="plaza-top-purchased">
          <header><h3>Recommended for you</h3></header>
          <div className="hpz-reco-grid">
            {topPurchased.slice(0, 15).map((p) => (
              <SmartProductCard
                key={p.sku}
                product={{
                  ...p,
                  images: p.image_url ? [{ public_url: p.image_url }] : [],
                }}
                onOpen={() => onOpen(p.sku)}
                onAdd={() => onAdd(p)}
                inWishlist={inWishlist(p.sku)}
                onToggleWishlist={() => onToggleWishlist(p.sku)}
              />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
